import protoComponent from './proto'
import { latlng, boundsFrom , latlngsFrom } from '../utils/conv'

export default {
  name: 'SlAmapOverlay',
  extends: protoComponent,
  data() {
    return {
      overlay: null,
    }
  },

  props: {
    overlayStyle: {
      type: Object,
      default: function() {
        return {
          strokeColor: '#4bd3b7',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#4bd3b7',
          fillOpacity: 0.15,
          strokeStyle: 'solid',
        }
      }
    },
    value:null,
  },
  created(){
    this.$watch('value' , function(v){
      if (v && v.type) {
        this.setGeometry(v)
      } else {
        this.setGeometry(null)
      }
    },{immediate:true})
  },
  methods: {
    $initComponent() {

      if (this.value) {
        this.setGeometry(this.value)
      }
    },

    draw(data) {
      let options = {
        map: this.$amap,
        ...this.overlayStyle
      }
      switch (data.type) {
        case 1:
          this.overlay = new AMap.Circle({
            center: data.center,
            radius: data.radius,
            ...options
          })
          break
        case 3:
          this.overlay = new AMap.Rectangle({
            bounds: data.bounds,
            ...options
          })
          break
        case 2:
          this.overlay = new AMap.Polygon({
            path: data.path,
            ...options
          })
          break
      }

      this.overlay.setMap(this.$amap)

      if (data.fit) {
        this.$amap.setFitView(null, true)
      }

    },

    clear() {
      if (this.overlay) {
        this.overlay.setMap(null)
        this.overlay = null
      }
    },

    setGeometry(d) {
      if (!this.ready) return
      if (d === null) {
        this.clear()
      } else {
        let { type, coordinates, radius } = d
        let data = { type }
        if (type == 1) {
          data.center = latlng(coordinates[0])
          data.radius = radius
          data.fit = true
        } else if (type == 3) {
          data.bounds = boundsFrom(coordinates)
          data.fit = true
        } else if (type == 2) {
          data.path = latlngsFrom(coordinates)
          data.fit = true
        }

        this.clear()
        this.draw(data)
      }

    },

    destroy() {

    }
  },
  render(){
    return <div></div>
  }
}